import { render } from "./gameCard.html?vue&type=template&id=f7a2df4c"
import script from "./gameCard.vue?vue&type=script&lang=ts"
export * from "./gameCard.vue?vue&type=script&lang=ts"

import "./gameCard.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script